import React, { useState } from "react";
import { SearchInput } from "../../Components";
import { SelectInput } from "../../Components";
import {
  download,
  plusIcon,
  searchIcon,
  systemIcon,
} from "../../Components/Base/SVG";
import { Pagination } from "../../Components";
import NotifMainItem from "./NotifMainItem";
import { NotifModul } from "./NotifModul";

const selectDescList = [
  { id: "title", value: "Title" },
  { id: "message", value: "Text" },
  { id: "assigned", value: "Assigned" },
  { id: "created_at", value: "Date" },
  { id: "status", value: "Status" },
];
export default function NotifMain({ searchText, search, changeMediumDesc, setTab, setTabData, tabData, paginationData, onPaginate, downloadCsv, setSearchTextOnChange }) {

  return (
    <div className="admnotif">
      <div className="admnotif__table-title">
        <div className="admnotif__table-title-info">
          <button className="button tertiary big" onClick={() => setTab("add")}>
            Create notification {plusIcon}
          </button>
          <button
            className="button tertiary big"
            onClick={() => { setTab("system"); onPaginate(1) }}
          >
            View system notification {systemIcon}
          </button>
        </div>
        <div className="admnotif__table-title-inner">
          <SelectInput
            list={selectDescList}
            selected={selectDescList[0]}
            onChange={changeMediumDesc}
          />

          <SearchInput
            value={searchText}
            onClick={search}
            type="text"
            icon={searchIcon}
            placeholder="Search"
            onChange={setSearchTextOnChange} />
        </div>
      </div>

      <div className="admnotif__table">
        <table>
          <thead>
            <tr>
              <th>Id</th>
              <th>Title</th>
              <th>Text</th>
              <th>Assigned</th>
              <th>Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {tabData.length > 0 && tabData.map((item, index) => {
              return (
                <NotifMainItem
                  onClick={() => {
                    setTab("edit");
                    setTabData(item);
                  }}
                  tab="main"
                  key={index}
                  {...item}
                />
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="admnotif__table-footer">
        <button className="button tertiary download" onClick={downloadCsv}>
          Download CSV {download}
        </button>
        <Pagination
          perPage={paginationData['per_page']}
          total={paginationData['total']}
          currentPage={paginationData['current_page']}
          totalPages={paginationData['total_pages']}
          onPaginate={onPaginate}
        />
      </div>
    </div>
  );
}
